// extracted by mini-css-extract-plugin
export default {"cls1":"TypeSelectionStep-StepContent_cls1__SGOJV","cls2":"TypeSelectionStep-StepContent_cls2__YlI9N TypeSelectionStep-StepContent_cls1__SGOJV"};